import { IPublicTicket } from '../../models'
import {
  AlterationsTypeKeys,
  ISetDisplayedActiveTicketsAction,
  ISetIsAlterationsModalOpenAction,
} from '../types'

export function setIsAlterationsModalOpenAction(show: boolean): ISetIsAlterationsModalOpenAction  {
  return { type: AlterationsTypeKeys.SET_ALTERATIONS_MODAL_OPEN, payload: show }
}

export function setDisplayedActiveTicketsAction(tickets: IPublicTicket[] | null): ISetDisplayedActiveTicketsAction {
  return { type: AlterationsTypeKeys.SET_DISPLAYED_ACTIVE_TICKETS, payload: tickets }
}
